/**
 * Dashboard date-window presets — leaf module with no metric-plan imports so
 * editors (MetricPlanEditor, ScopeWindow) can read the list without pulling
 * in useScopedMetrics (which would circularly depend on metricPlan).
 */

export const WINDOWS = [
  { id: "today", label: "Today" },
  { id: "yesterday", label: "Yesterday" },
  { id: "week", label: "This week" },
  { id: "lastWeek", label: "Last week" },
  { id: "lastMonth", label: "Last month" },
  { id: "month", label: "This month" },
  { id: "quarter", label: "This quarter" },
  { id: "ytd", label: "Year to date" },
  { id: "year", label: "This year" },
  { id: "custom", label: "Custom range" },
];

export const windowLabel = (id) =>
  (WINDOWS.find((w) => w.id === id) || WINDOWS.find((w) => w.id === "month")).label;
